import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Library } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { PlaceholderPage } from './PlaceholderPage';
/**
 * V2 Sources page — single component handling all reference views via the
 * `:sourceKey` URL param.
 *
 * PR2: placeholder. PR3 lifts each existing legacy tab (FilesTab, CLINsTab,
 * LCATsTab, PricingTab, TeamTab, MasterMatrixTab) into per-key page components
 * mounted from this route.
 */ export function SourcesPage() {
    const { sourceKey } = useParams();
    return /*#__PURE__*/ _jsx(PlaceholderPage, {
        icon: /*#__PURE__*/ _jsx(Library, {
            className: "h-5 w-5 text-slate-500",
            "aria-hidden": "true"
        }),
        title: "Sources",
        eyebrow: "Reference lens",
        description: "PR3 lifts every existing tab here as-is.",
        meta: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "sourceKey: ",
                /*#__PURE__*/ _jsx("span", {
                    className: "font-mono",
                    children: sourceKey
                })
            ]
        })
    });
}
